import React, {Component} from 'react';
import Page from '../../components/Page';
import './styles.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import {getMyVacations, openVacationRequest, cancelVacationRequest} from '../../actions/vacation';
import {getHolidays} from '../../actions/holidays';

import { DateRangePicker } from 'react-dates';

const DEFAULT_STATE = {
    startDate: null,
    endDate: null,
    focusedInput: null,
};

class Vacation extends Component {

    constructor(props) {
        super(props);
        this.state = DEFAULT_STATE;
        this._onFocusChange = this._onFocusChange.bind(this);
        this._onDatesChange = this._onDatesChange.bind(this);
        this._onClickOpenRequest = this._onClickOpenRequest.bind(this);
        this._isDayBlocked = this._isDayBlocked.bind(this);
        this._onClickCancelVacation = this._onClickCancelVacation.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(getMyVacations());
        this.props.dispatch(getHolidays());
    }

    _isDayBlocked(day) {
        let isHoliday = false;
        for (let i = 0; i < this.props.holidays.length; i++) {
            if (this.props.holidays[i].isSame(day, 'day')) {
                isHoliday = true;
                break;
            }
        }
        if (day.isoWeekday() < 6 && !isHoliday) {
            return false;
        }

        return true;
    }

    _onDatesChange({startDate, endDate}) {
        this.setState({startDate, endDate});
    }

    _onFocusChange(focusedInput) {
        this.setState({focusedInput});
    }

    _onClickOpenRequest() {
        if (this.state.startDate && this.state.endDate) {
            let vacation = {
                userId: this.props.user._id,
                startAt: this.state.startDate.clone().toDate(),
                endAt: this.state.endDate.clone().toDate(),
            };
            this.props.dispatch(openVacationRequest((error, json) => {
                if (!error) {
                    this.setState(DEFAULT_STATE);
                }
            }, vacation));
        }
    }

    _onClickCancelVacation(vacation) {
        this.props.dispatch(cancelVacationRequest(()=>{}, vacation._id));
    }

    _statusBadge(status) {
        return <span className={'Badge Badge--' + status}>{status}</span>;
    }

    render() {
        let disabled = !(this.state.startDate && this.state.endDate);

        let upcoming = [];
        let past = [];

        if (this.props.vacations.length) {
            this.props.vacations.forEach((vacation, index) => {
                if (['open', 'approved'].indexOf(vacation.status) === -1) {
                    return;
                }

                let startAt = moment(vacation.startAt).format("DD/MM/YYYY");
                let endAt = moment(vacation.endAt).format("DD/MM/YYYY");

                // skip previous years vacations
                if (moment(vacation.startAt).isBefore(moment(), 'year')) {
                    return;
                }

                if (moment().isBefore(vacation.startAt)) {
                    upcoming.push(<tr key={'upcoming_vacations_' + index}>
                        <td className="tabular">{startAt}</td>
                        <td className="tabular">{endAt}</td>
                        <td className="tabular">{vacation.days}</td>
                        <td>{this._statusBadge(vacation.status)}</td>
                        <td><button onClick={()=> this._onClickCancelVacation(vacation)} className="btn btn-default" title="Cancel vacation">
                            <i className="fa fa-times" aria-hidden="true" style={{color:'var(--danger)'}}></i>
                        </button></td>
                    </tr>);
                } else {
                    past.push(<tr key={'past_vacations_' + index}>
                        <td className="tabular">{startAt}</td>
                        <td className="tabular">{endAt}</td>
                        <td className="tabular">{vacation.days}</td>
                        <td>{this._statusBadge(vacation.status)}</td>
                        <td></td>
                    </tr>);
                }

            });
        }

        const emptyRow = (key, msg) => (
            <tr key={key}><td colSpan="5"><div className="Empty"><i className="fa fa-suitcase" /><div className="t">{msg}</div></div></td></tr>
        );
        if (!upcoming.length) { upcoming.push(emptyRow('upcoming_empty', 'No upcoming vacations')); }
        if (!past.length) { past.push(emptyRow('past_empty', 'Nothing here yet')); }

        return (
            <Page {...this.props} >
                <div className="col-xs-12">
                    <div className="Card Vacation-Panel">
                        <div className="Title"><span>Request vacation</span></div>
                        <div className="Request-Row">
                            <div className="Center">
                                <DateRangePicker
                                    minimumNights={0}
                                    isDayBlocked={(day) => this._isDayBlocked(day)}
                                    startDate={this.state.startDate}
                                    startDateId="vacation-start-date"
                                    endDateId="vacation-end-date"
                                    endDate={this.state.endDate}
                                    onDatesChange={this._onDatesChange}
                                    focusedInput={this.state.focusedInput}
                                    onFocusChange={this._onFocusChange}
                                    firstDayOfWeek={1}
                                    displayFormat={'DD/MM/YYYY'}
                                    isOutsideRange={() => false}
                                />
                            </div>
                            <button disabled={disabled} onClick={this._onClickOpenRequest} className="btn btn-primary Open-Request-Btn">
                                <i className="fa fa-paper-plane" aria-hidden="true" /> Open request
                            </button>
                        </div>
                    </div>

                    <div className="Card Vacation-Panel">
                        <div className="Title"><span>Upcoming vacations</span></div>
                        <div className="Table-Wrap">
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Start date</th>
                                    <th scope="col">End date</th>
                                    <th scope="col">Days</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Actions</th>
                                </tr>
                                </thead>
                                <tbody>{upcoming}</tbody>
                            </table>
                        </div>
                    </div>

                    <div className="Card Vacation-Panel">
                        <div className="Title"><span>Past vacations</span></div>
                        <div className="Table-Wrap">
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Start date</th>
                                    <th scope="col">End date</th>
                                    <th scope="col">Days</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Actions</th>
                                </tr>
                                </thead>
                                <tbody>{past}</tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
}
Vacation.propTypes = {
    user: PropTypes.object,
    vacations: PropTypes.arrayOf(PropTypes.object),
    holidays: PropTypes.arrayOf(PropTypes.object),
};

Vacation.defaultProps = {
    vacations: [],
    user: {},
    holidays: []
};


function mapStateToProps(state) {
    const user = state.authentication.user;
    const vacations = state.vacation;
    let holidays = [];
    state.holidays.forEach(holiday => {
        let year = holiday.year || moment().year();
        if (year !== moment().year()) {
            return;
        }
        holidays.push(moment(new Date(year, holiday.month-1, holiday.day)));
    });
    return {
        user: user,
        vacations: vacations,
        holidays: holidays
    };
}

export default connect(mapStateToProps)(Vacation);



// WEBPACK FOOTER //
// ./src/screens/Vacation/index.js